/* eslint-disable */
import mixpanel from "mixpanel-browser";
import { GTMButtonClick, GTMPageView, GTMCustomEvent } from "./GTM";
import ReactPixel from 'react-facebook-pixel';

ReactPixel.init(process.env.REACT_APP_FB_PIXEL, {
  autoConfig: true,
  debug: process.env.NODE_ENV === 'development',
});

mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN);

const actions = {
  pageView: (url) => {
    mixpanel.track('app' + url);
    ReactPixel.track('app' + url);
    GTMPageView('app' + url);
  },
  buttonClick: (events) => {
    events.forEach(event => {
      mixpanel.track(event);
      ReactPixel.track(event);
      GTMButtonClick(event);
    })
  },
  conversion: (id) => {
    mixpanel.track(id);
    ReactPixel.track(id);
  },
  only: {
    fb: (event) => {
      ReactPixel.track(event);
    },
    g: (event) => {
      GTMCustomEvent(event);
    },
    mp: (event) => {
      mixpanel.track(event);
    },
  }
};

export const Mixpanel = actions;